(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-image-popup]';
    var OPEN_CLASS = 'is-open';
    var LOCK_CLASS = 'image-popup-open';
    var timer = null;
    var lastFocused = null;

    function getPopup() {
      return document.querySelector(SELECTOR);
    }

    function openPopup(popup) {
      if (!popup || popup.classList.contains(OPEN_CLASS)) return;
      lastFocused = document.activeElement;
      popup.classList.add(OPEN_CLASS);
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add(LOCK_CLASS);
      var closeBtn = popup.querySelector('.image-popup__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closePopup(popup) {
      if (!popup) return;
      popup.classList.remove(OPEN_CLASS);
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove(LOCK_CLASS);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
      lastFocused = null;
    }

    function schedule() {
      clearTimeout(timer);
      var popup = getPopup();
      if (!popup) return;
      var delay = (parseFloat(popup.getAttribute('data-delay')) || 0) * 1000;
      timer = setTimeout(function () {
        openPopup(popup);
      }, delay);
    }

    /* Close: close icon + overlay click */
    document.addEventListener('click', function (event) {
      var closeEl = event.target.closest('[data-image-popup-close]');
      if (!closeEl) return;
      closePopup(closeEl.closest(SELECTOR));
    });

    /* ESC to close + keep focus inside popup */
    document.addEventListener('keydown', function (event) {
      var popup = getPopup();
      if (!popup || !popup.classList.contains(OPEN_CLASS)) return;

      if (event.key === 'Escape') {
        closePopup(popup);
        return;
      }

      if (event.key === 'Tab') {
        var focusable = popup.querySelectorAll('a[href], button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!popup.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    /* Show on window load */
    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule);
    }

    /* Theme editor support */
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector(SELECTOR)) openPopup(getPopup());
    });
    document.addEventListener('shopify:section:select', function (event) {
      if (event.target.querySelector(SELECTOR)) openPopup(getPopup());
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      if (event.target.querySelector(SELECTOR)) closePopup(getPopup());
    });
    document.addEventListener('shopify:section:unload', function () {
      document.documentElement.classList.remove(LOCK_CLASS);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
